import {Field} from 'react-final-form';

import * as tw from 'src/lib/tailwindClasses';
import {Locale} from 'src/lib/translations';
import FormSection from 'src/pages/Settings/FormSection';

import {useTranslations} from './TranslationsContext';

// Map of language codes to their display names
const languageNames: Record<Locale, string> = {
  en: 'English',
  fr: 'Français',
  ja: '日本語',
  pt: 'Português',
  ru: 'Русский',
};

export default function LanguageSelector() {
  const {locale, changeLocale, t} = useTranslations();

  return (
    <FormSection
      name={t('languagePreferences')}
      description={t('appliesOnlyToCurrentUser')}
      isLoading={false}
      initialValues={{language: locale}}
      onSubmit={(value) => changeLocale(value.language as Locale)}
      render={() => {
        return (
          <div className="col-span-6 sm:col-span-3">
            <label htmlFor="language" className="block text-sm font-medium text-gray-700">
              {t('languagePreferences')}
            </label>
            <Field name="language" component="select" className={tw.formSelect}>
              {Object.keys(languageNames).map((code) => (
                <option key={code} value={code}>
                  {languageNames[code as Locale] || code.toUpperCase()}
                </option>
              ))}
            </Field>
          </div>
        );
      }}
    />
  );
}
